import { createNamespace } from '../utils';

var _createNamespace = createNamespace('color'),
    createComponent = _createNamespace[0];

export default createComponent({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/color/index.js
// module id = null
// module chunks = 